import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUnreadCount } from '../redux/slices/inboxSlice';

const BASE_TITLE = 'ARA HumanSync';
const ICON_SRC = `${process.env.PUBLIC_URL || ''}/favicon.ico`;
const GLOW = [124, 92, 252];

export default function TabBadge() {
    const unread = useSelector(selectUnreadCount);
    const linkRef = useRef(null);
    const imgRef = useRef(null);
    const [loaded, setLoaded] = useState(0);

    useEffect(() => {
        let link = document.querySelector('link#ara-fav');
        if (!link) {
            document.querySelectorAll('link[rel~="icon"]').forEach((l) => l.parentNode && l.parentNode.removeChild(l));
            link = document.createElement('link');
            link.id = 'ara-fav';
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        linkRef.current = link;

        const img = new Image();
        img.onload = () => { imgRef.current = img; setLoaded((v) => v + 1); };
        img.src = ICON_SRC;
    }, []);

    useEffect(() => {
        const img = imgRef.current;
        const size = 64;
        const canvas = document.createElement('canvas');
        canvas.width = size; canvas.height = size;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const cx = size / 2;
        const glow = unread > 0 ? 0.6 : 0;

        ctx.clearRect(0, 0, size, size);
        if (glow > 0) {
            const a = 0.22 + 0.5 * glow;
            const g = ctx.createRadialGradient(cx, cx, size * 0.08, cx, cx, size * 0.52);
            g.addColorStop(0, `rgba(${GLOW[0]},${GLOW[1]},${GLOW[2]},${a})`);
            g.addColorStop(0.55, `rgba(${GLOW[0]},${GLOW[1]},${GLOW[2]},${a * 0.35})`);
            g.addColorStop(1, `rgba(${GLOW[0]},${GLOW[1]},${GLOW[2]},0)`);
            ctx.fillStyle = g;
            ctx.fillRect(0, 0, size, size);
        }
        if (img) {
            const s = glow > 0 ? 0.84 : 0.94;
            const w = size * s; const off = (size - w) / 2;
            ctx.drawImage(img, off, off, w, w);
        }
        if (linkRef.current && (img || glow > 0)) linkRef.current.href = canvas.toDataURL('image/png');
    }, [unread, loaded]);

    useEffect(() => {
        document.title = BASE_TITLE;
        if (unread <= 0) return undefined;
        let timer = null;
        let flip = false;
        const label = `💬 ${unread > 99 ? '99+' : unread} new message${unread > 1 ? 's' : ''}`;
        const tick = () => {
            if (!document.hidden) return;
            flip = !flip;
            document.title = flip ? label : BASE_TITLE;
            timer = window.setTimeout(tick, 1500);
        };
        const onVis = () => {
            window.clearTimeout(timer);
            if (document.hidden) tick();
            else document.title = BASE_TITLE;
        };
        document.addEventListener('visibilitychange', onVis);
        if (document.hidden) tick();
        return () => { window.clearTimeout(timer); document.removeEventListener('visibilitychange', onVis); };
    }, [unread]);

    return null;
}
